import React from "react";
// import loader from "./770.gif";

function Loader(){
    return(
        <div className="loading">
          {/* <img src={loader} alt="" /> */}
          <p>Activities are currently not available.</p>
        </div>
    );
}

export default Loader;